import { render, staticRenderFns } from "./pintuan.vue?vue&type=template&id=018790e7&scoped=true"
import script from "./pintuan.vue?vue&type=script&lang=js"
export * from "./pintuan.vue?vue&type=script&lang=js"
import style0 from "./pintuan.vue?vue&type=style&index=0&id=018790e7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018790e7",
  null
  
)

export default component.exports